import { Country } from 'src/enums/countries'

export interface ClientIdentificationFlat {
  nit: string | null
  cui: string | null
  nrc: string | null
  foreignId: string | null
  rtn: string | null
  dni: string | null
}

export interface ClientBalanceResponse {
  id: number
  code: string
  name: string
  identification: ClientIdentificationFlat
  balance: number
  vouchers: number
  creditNotes: number
}

const FALLBACK = 'CF'

const priorityByCountry: { [key: number]: (keyof ClientIdentificationFlat)[] } = {
  [Country.GT]: ['nit', 'cui'],
  [Country.SV]: ['nit', 'cui', 'nrc'],
  [Country.HN]: ['rtn', 'dni'],
}

/**
 * Identificación a mostrar por país (fallback 'CF'):
 * GT: nit → cui · SV: nit → cui(DUI) → nrc · HN: rtn → dni.
 */
export const getClientIdentification = (
  identification: ClientIdentificationFlat | null | undefined,
  country: number,
): string => {
  if (!identification) return FALLBACK
  const priority = priorityByCountry[country] || ['nit']
  for (const field of priority) {
    const value = identification[field]
    if (value) return value
  }
  return FALLBACK
}
